import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="relative min-h-screen w-full bg-slate-950 overflow-hidden flex items-center" data-id="element-188">
      {/* Background Image - CAF Team */}
      <div className="absolute inset-0 z-0" data-id="element-189">
        <img src="https://cdn.magicpatterns.com/uploads/4JTgtxdfp54i1AveSMzANu/CAF_loading.jpg" alt="CAF Team Background" className="w-full h-full object-cover opacity-10 mix-blend-overlay" data-id="element-190" />
        {/* Heavy gradient overlay to ensure text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/95 to-slate-950/90" data-id="element-191" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/80 via-transparent to-slate-950" data-id="element-192" />
      </div>

      {/* Radial glow */}
      <div className="absolute top-1/3 right-1/4 w-[600px] h-[600px] bg-tiq-purple/20 rounded-full blur-[150px] z-0" data-id="element-193" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32" data-id="element-194">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center" data-id="element-195">
          {/* Left — Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-196">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-tiq-purple/30 bg-tiq-purple/10 mb-8" data-id="element-197">
              <div className="w-1.5 h-1.5 rounded-full bg-tiq-green animate-pulse" data-id="element-198" />
              <span className="text-xs font-mono text-tiq-blue uppercase tracking-wider" data-id="element-199">
                Readiness Intelligence
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1] tracking-tight mb-6" data-id="element-200">
              Operational Readiness Starts Before Deployment.
            </h1>

            <p className="text-lg md:text-xl text-tiq-blue/80 leading-relaxed mb-4 max-w-xl" data-id="element-201">
              TalentIQ builds readiness intelligence infrastructure for
              mission-critical organizations.
            </p>

            <p className="text-sm font-mono text-slate-400 mb-10" data-id="element-202">
              Traditional systems track hiring. TalentIQ measures whether teams
              are actually ready to execute.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-203">
              <a href="https://form.typeform.com/to/XVTziLCj" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-tiq-purple hover:bg-violet-500 text-white font-semibold rounded-lg transition-colors duration-200 shadow-lg shadow-tiq-purple/20" data-id="element-204">
                Get a Free Readiness Assessment
                <ArrowRightIcon className="w-4 h-4" data-id="element-205" />
              </a>
              <a href="https://calendly.com/hello-talentiqtech/enterprisedemo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-tiq-purple/40 text-tiq-blue hover:bg-tiq-purple/10 font-semibold rounded-lg transition-colors duration-200" data-id="element-206">
                Book Your Readiness Index Preview
              </a>
            </div>
          </motion.div>

          {/* Right — Dashboard Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 1,
          ease: 'easeOut',
          delay: 0.3
        }} className="relative flex justify-center lg:justify-end" data-id="element-207">
            <div className="relative w-full max-w-none z-10" data-id="element-208">
              <img src="https://cdn.magicpatterns.com/uploads/4SWM7fjtU3w1zozpR9BYaM/TalentIQ_logo_assets_(3).png" alt="TalentIQ Intelligence Infrastructure Stack" className="w-full h-auto drop-shadow-2xl scale-110 origin-center lg:origin-left" style={{
              mixBlendMode: 'normal'
            }} data-id="element-209" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}